<template>
  <footer>
    <div class="footer-container">
      <!-- 상단: 3개 버튼 -->
      <div class="footer-top">
        <ul class="footer-links">
          <li><router-link to="/auth/privacy">개인정보처리방침</router-link></li>
          <li><router-link to="/auth/terms">서비스이용약관</router-link></li>
          <li><router-link to="/support/so_c5000">고객센터</router-link></li>
        </ul>
      </div>
      
      <!-- 회사명 -->
      <p class="company-name">주식회사 빌리언대부</p>
      
      <!-- 하단: 회사정보 -->
      <div class="footer-bottom">
        <address class="company-info">
          <strong>대표자</strong> : 김재연<br>
          <strong>사업자등록번호</strong> : 260-87-00831<br>
          <strong>등록번호</strong> : 2022-금감원-2382(대부업) / 2022-금감원-2382(대부중개업)<br>
          <strong>주소</strong> : 서울특별시 노원구 동일로178길 19-38, 6층(공릉동, 연세빌딩)
        </address>
        <div class="company-tel">
          <address>
            <strong>고객문의</strong> : 1833-8996<br>
            <strong>개인정보보호책임자</strong> : 차승현<br>
            <strong>대부업 등록기관명칭</strong> : 금융감독원(1332)
          </address>
        </div>
      </div>
      
      <p class="copyright">Copyright ⓒ {{ currentYear }}. 주식회사 빌리언대부. All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const currentYear = ref(new Date().getFullYear())

onMounted(() => {
  currentYear.value = new Date().getFullYear()
})
</script>

<style>
@import '@/assets/styles/style.css';
@import '@/assets/styles/include.css';
</style>
